export const ACCEPT_ALL_PATTERN = /[\s\S]*/;
export const TH_MOBILE_NO_PATTERN = /0([689]\d{8}|[23457]\d{7})$/;
export const ID_MOBILE_NO_PATTERN =
  /^(\(\+62|62|0)(\d{2,3})?\)?[ .-]?\d{2,4}[ .-]?\d{2,5}$/;
export const DECIMAL_PATTERN = /^\d+(?:\.\d+)?$/;
export const TH_CID_PATTERN = /^[1-9]\d{4}\d{5}\d{2}\d$/;
export const ID_CID_PATTERN = /^\d{2}[01237]\d{3}[01234567]\d[01]\d{7}$/;
export const ONE_TO_HUNDRED_PATTERN = /^[1-9]\d?$|^100$/;
export const BANK_ACCOUNT_NO_PATTERN = /^[A-Za-z0-9]+$/;
export const EMAIL_PATTERN =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const ONLY_TH_EN_PATTERN = /^[a-zA-Z\u0E00-\u0E7F\s]*$/;
export const EN_NUM_SYMBOL = /^[a-zA-Z0-9-_]*$/;
export const ONLY_EN_NUM_UNDERSCORE_DASH_CHAR_PATTERN = /[^a-zA-Z0-9\-_]/g;
export const ID_RW_PATTERN = /^\d{3}$/;
export const ID_RT_PATTERN = /^\d{3}$/;
export const SPLIT_PATH = /^\/([^/]+)/;
export const YYYY_MM_DD_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
export const E164_CONTACT_NO_PATTERN = /^\+\d{10,11}$/;
export const EMAIL_PATTERN_V2 =
  // eslint-disable-next-line no-control-regex, no-useless-escape
  /(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
